import * as z from "zod/v4";

export const updateShipHeroIntegration = {
  name: "updateShipHeroIntegration" as const,
  input: z.object({ customerAccountID: z.string().optional() }),
  output: z.object({}),
};

export type UpdateShipHeroIntegrationInput = z.infer<
  typeof updateShipHeroIntegration.input
>;

export const setShipHeroIntegration = {
  name: "setShipHeroIntegration" as const,
  input: z.object({
    refreshToken: z.string().min(1, "Refresh token is required"),
    customerAccountID: z.string().optional(),
  }),
  output: z.object({}),
};

export type SetShipHeroIntegrationInput = z.infer<
  typeof setShipHeroIntegration.input
>;

export const getShipHeroIntegration = {
  name: "getShipHeroIntegration" as const,
  input: z.object({}),
  output: z.object({
    shipHeroIntegration: z.optional(
      z.object({
        customerAccountID: z.string().optional(),
        createReturns: z.boolean(),
      }),
    ),
  }),
};

export type GetShipHeroIntegrationOutput = z.infer<
  typeof getShipHeroIntegration.output
>;

export const disconnectShipHeroIntegration = {
  name: "disconnectShipHeroIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
